<!-- 模块-切换站点 -->
<template>
  <span>
    <van-cell v-if="data.length === 1" icon="location-o" size="large" :title="name" />
    <van-cell v-else icon="location-o" size="large" :title="name" is-link value="切换站点" @click="ifShow = true" />

    <!-- 选择站点 -->
    <van-popup v-model="ifShow" round position="bottom">
      <van-picker show-toolbar :columns="picker_data" @cancel="ifShow = false" @confirm="confirm"/>
    </van-popup>
  </span>
</template>

<script>
export default {
  name: 'oiling_site',
  data () {
    return {
      ifShow: false,
      data: [],
      picker_data: [],
      name: '加油站'
    }
  },

  methods: {
    // 获取站点数据
    get_data () {
      this.get_site_data(this, false, (res) => {
        this.data = res
        this.name = res[0].name
        this.$emit('get_site_id', res[0].s_id)
        this.set_picker(res)
      })
    },

    // 计算选择数据
    set_picker (data) {
      if (data.length === 1) { return }
      data.forEach((val, key) => {
        this.picker_data.push({ text: val.name + '&nbsp;&nbsp;-&nbsp;&nbsp;' + val.km + 'km' })
      })
    },

    // 选中新站点
    confirm (val, key) {
      this.name = this.data[key].name
      this.$emit('get_site_id', this.data[key].s_id)
      this.ifShow = false
      if (this.data[key].km > 3) {
        this.$dialog({
          showCancelButton: true,
          title: '提示！',
          message: '你的位置距离油站太远是否继续'
        }).then(() => {
          this.name = this.data[key].name
        }).catch(() => {
          this.ifShow = true
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/oiling/site.vue